import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router';
import useAffordance from 'Hooks/useAffordance';

const defaultState = {};

const FlowContext = createContext(defaultState);

const FlowContextProvider = ({ children }) => {
  const history = useHistory();
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  const searchLink = search.get('link');
  const url = new URL(window.location.href);

  const [currentStepIndex, setCurrentStepIndex] = useState(Number(url.searchParams.get('flowStepIndex')) || 0);

  const {
    loading,
    loadingError,
    collection: flowCollection,
  } = useAffordance(searchLink);

  const leaveFlow = () => {
    const urlAtCompletion = new URL(window.location.href);

    urlAtCompletion.searchParams.delete('flowStepIndex');
    urlAtCompletion.searchParams.delete('link');

    history.replace({
      search: urlAtCompletion.search,
    });

    history.goBack();
  };

  const navigateToPreviousStep = () => {
    setCurrentStepIndex((prevState) => {
      const newStepIndex = prevState - 1;

      const stateUrl = new URL(window.location.href);
      stateUrl.searchParams.set('flowStepIndex', String(newStepIndex));

      history.replace({
        search: stateUrl.search,
      });

      return newStepIndex;
    });
  };

  const navigateToNextStep = () => {
    setCurrentStepIndex((prevState) => {
      const newStepIndex = prevState + 1;

      const stateUrl = new URL(window.location.href);
      stateUrl.searchParams.set('flowStepIndex', String(newStepIndex));

      history.replace({
        search: stateUrl.search,
      });

      return newStepIndex;
    });
  };

  let currentStep = null;
  let totalSteps = null;

  if (flowCollection) {
    const [flowResource] = flowCollection;
    currentStep = flowResource?.attr('flowSteps').resources().index(currentStepIndex);
    totalSteps = Number(currentStep.attr('maxSteps'));
  }

  return (
    <FlowContext.Provider
      value={{
        loading,
        loadingError,
        flowCollection,
        leaveFlow,
        completeFlow: leaveFlow, // Same for now
        navigateToNextStep,
        navigateToPreviousStep,
        currentStepIndex,
        currentStepNumber: currentStepIndex + 1, // Adjust from 0 to 1 indexed
        currentStep,
        totalSteps,
        isFirstStep: currentStepIndex === 0,
        isLastStep: currentStepIndex === totalSteps - 1,
      }}
    >
      {children}
    </FlowContext.Provider>
  );
};

export const useFlowContext = () => {
  const context = useContext(FlowContext);

  if (!context) throw new Error('useFlowContext must be called from FlowContext.Provider');

  return context;
};

FlowContextProvider.propTypes = {
  children: PropTypes.any.isRequired,
};

export default FlowContextProvider;
